import React, { useState, useEffect, } from 'react';
import { useLocation } from 'react-router-dom';
import { Input, Select, Button, Space, Typography, Checkbox, Table, Badge, Radio, Empty, Flex, Descriptions } from 'antd';
import { Card } from '../../UI/Card/Card.component';
import { Modal } from '../../UI/Modal/Modal.component';
import { maskPhoneNumber } from '../../../Validation';
import { advancedFilter } from '../../../services/StationService';

const { Option } = Select;
const { Title, Text } = Typography;

export const StationAdvancedFilterModal = ({...props}) => {

    // const [form] = Form.useForm();
    // const [formValuesChanged, setFormValuesChanged] = useState(false);

    const location = useLocation();
    const { currentNocItem } = location.state;
    const customerId = currentNocItem.id;
    const customerStatus = currentNocItem.Places?.some(place => place.status);

    const [displayColumns, setDisplayColumns] = useState(['status', 'oracleID', 'contractNumber', 'devices', 'comment']);
    const [dataSource, setDataSource] = useState([]);
    // const [selectedFilter, setSelectedFilter] = useState();
    const [advancedFilters, setAdvancedFilters] = useState();
    const [filteredDataSource, setFilteredDataSource] = useState();
    const [tableSize, setTableSize] = useState('middle');
    const [searchText, setSearchText] = useState("");
    const [searchColumn, setSearchColumn] = useState(undefined)

    useEffect(() => {
        advancedFilter({ownerID: customerId}).then(response => {
            if(response){
                setDataSource(response)
            }
        }) 
    }, [])

    const columnsList = [
        {
            label: 'Address',
            value: 'address',
        },
        {
            label: 'Comment',
            value: 'comment'
        },
        {
            label: 'Contract Number',
            value: 'contractNumber',         
        },
        {
            label: 'Devices',
            value: 'devices',
        }, 
        {
            label: 'Internet Status',
            value: 'status',
        },
        {
            label: 'Oracle ID',
            value: 'oracleID'
        },  
        {
            label: 'Phone Carrier',
            value: 'phoneCarrier', 
        },
        {
            label: 'Phone Number',
            value: 'phone', 
        }, 
    ];

    const deviceTypeOptions = [
        {
            label: 'All', 
            value: 'all'
        }, 
        {
            label: 'AAP', 
            value: 'AAP'
        }, 
        {
            label: 'CAP',
            value: 'CAP',
        }, 
        {
            label: 'CS', 
            value: 'CS', 
        }, 
        {
            label: 'CS-BASE', 
            value: 'CSBASE'
        }, 
        {
            label: 'CS-DFS',
            value: 'CSDFS',
        },
        {
            label: 'CS-EVC',
            value: 'CSEVC',
        }, 
        {
            label: 'LTE',
            value: 'LTE',
        },         
        {
            label: 'LTE-EVC',
            value: 'LTEEVC',
        },
        {
            label: 'LTE-FMS',
            value: 'LTEFMS',
        }, 
        {
            label: 'SNS',
            value: 'SNS',
        }, 
        {
            label: 'SNS-BASE',
            value: 'SNSBASE',
        }, 
        {
            label: 'SNS-DFS',
            value: 'SNSDFS',
        }, 
        {
            label: 'SNS-GVR',
            value: 'SNSGVR',
        }, 
        {
            label: 'SUSW',
            value: 'SUSW',
        }, 
    ]

    const columns = [
        {
            title: 'Station', 
            dataIndex: 'name',
            key: 'name',
            render: (value) => {
                return(
                    <Space className='hover--copyable'>
                        <Text copyable>{value}</Text>
                    </Space>
                );
            }
        },
        {
            title: 'Internet Status', 
            dataIndex: 'status',
            key: 'status',
            hidden: !displayColumns.includes('status'),
            render: (value) => {
                return <Badge status={value ? 'success' : 'error'} text={value ? 'Active' : 'Inactive'}/>
            }
        },
        {
            title: 'Oracle ID', 
            dataIndex: 'oracleID',
            key: 'oracleID',
            hidden: !displayColumns.includes('oracleID')
        },
        {
            title: 'Contract Number', 
            dataIndex: 'contractNumber',
            key: 'contractNumber',
            hidden: !displayColumns.includes('contractNumber')
        },
        {
            title: 'Address',
            dataIndex: 'streetAddress',
            key: 'address',
            hidden: !displayColumns.includes('address'),
            render: (_, record) => {
                const { streetAddress, city, state, zip, } = record;
                const fullAddress = [ streetAddress, city, state, zip ];
                return fullAddress.every(element => element === null) ? ' ' : fullAddress.join(' ');
            }
        },
        {
            title: 'Phone Number',
            dataIndex: 'phone', 
            key: 'phone',
            hidden: !displayColumns.includes('phone')
        },
        {
            title: 'Phone Carrier',
            dataIndex: 'phoneCarrier', 
            key: 'phoneCarrier',
            hidden: !displayColumns.includes('phoneCarrier')
        },
        {
            title: 'Total Devices', 
            dataIndex: 'devices', 
            key: 'devices',
            hidden: !displayColumns.includes('devices'),
            render: (_, record) => {return record.Devices?.length},
        },
        {
            title: 'Total MAC Devices', 
            dataIndex: 'macDevices', 
            key: 'macDevices',
            hidden: !displayColumns.includes('devices'),
            render: (_, record) => { return record.Macdevices?.length } 
        },
        {
            title: 'Comment',
            dataIndex: 'comment', 
            key: 'comment',
            hidden: !displayColumns.includes('comment')
        },
    ].filter(column => !column.hidden);

    const deviceTableColumns = [
        {
            title: 'Serial Number', 
            dataIndex: 'serialNum', 
            key: 'serialNum', 
            render: (value) => {
                return(
                    <Space className='hover--copyable'>
                        <Text copyable>{value}</Text>
                    </Space>
                );
            }
        }, 
        {
            title: 'Device Type', 
            dataIndex: 'deviceType', 
            key: 'deviceType'
        }, 
        {
            title: 'VPN Status', 
            dataIndex: 'status', 
            render: (value) => {
                return <Badge status={value ? 'success' : 'error'} text={value ? 'Active' : 'Inactive'}/>
            }
        }
    ]

    const filterColumns = (columns) => {
        setDisplayColumns(columns);
    }

    const getFilteredResults = (filter) => {

        const { searchBy, query } = filter;

        let filteredResults;
        let searchQuery = typeof query !== 'boolean' ? query?.toLowerCase() : null;

        if(!displayColumns.includes(searchBy)){
            setDisplayColumns([...displayColumns, searchBy]);
        }

        switch (searchBy) {
            case 'status': 
                filteredResults = dataSource.filter(data => data.status === query);
                break;
            case 'serialNum': 
                filteredResults = dataSource.filter((data) => data.Devices.some(device => device.serialNum.toLowerCase().includes(searchQuery)));
                break;
            case 'address':
                filteredResults = dataSource.filter(data => 
                    data['streetAddress']?.toLowerCase().includes(searchQuery) || 
                    data['city']?.toLowerCase().includes(searchQuery) ||
                    data['state']?.toLowerCase().includes(searchQuery) ||
                    data['zip']?.toLowerCase().includes(searchQuery)
                );
                break;
            case 'devices':
                if(query !== 'all'){
                    const csType = ['CS', 'SW'];
                    const subsUnitType = ['SUSW', 'SWSU', 'SWSUCL'];

                    if(filter.query === 'CS'){
                        filteredResults = dataSource.filter(data => data.Devices.some(device => csType.includes(device.deviceType)));
                    } else if(filter.query === 'SUSW'){
                        filteredResults = dataSource.filter(data => data.Devices.some(device => subsUnitType.includes(device.deviceType)));
                    } else {
                        filteredResults = dataSource.filter(data => data.Devices.some(device => device.deviceType === filter.query));
                    }
                }
                break
            default: 
                filteredResults = dataSource.filter(data => data[filter.searchBy]?.toLowerCase().includes(searchQuery));
                break;
        }

        if(query === 'all'){
            resetTable();
        } else{
            setAdvancedFilters(filter);
            setFilteredDataSource(filteredResults);
        }
    }

    const getCustomerStats = (type) => {

        let result; 
        
        switch(type) {
            case 'activeStations':
                result = dataSource?.reduce((count, data) => (data.status ? count + 1 : count), 0);
                break;
            case 'inactiveStations':
                result = dataSource?.reduce((count, data) => (!data.status ? count + 1 : count), 0);
                break;
            case 'hasDevices':
                result = dataSource?.reduce((count, data) => (data.Devices?.length > 0 ? count + 1 : count), 0) 
                break;
            case 'devices':
                result = dataSource?.reduce((count, data) => data.Devices?.length > 0 ? count + data.Devices.length : count, 0);
                break;
            default: 
                break;
        }

        return result;
    }

    const resetTable = () => {
        setFilteredDataSource([]);
        setAdvancedFilters('');
        // form.resetFields();
    }

    // const removeColumn = (column) =>{
    //     setDisplayColumns(displayColumns => displayColumns.filter(item => item !== column))
    // }

    const tableSizeOptions = [
        {
            label: 'Default', 
            value: 'middle', 
        }, 
        {
            label: 'Compact', 
            value: 'small'
        }, 
        {
            label: 'Comfortable',
            value: 'large', 
        }
    ];

    // const onFormValuesChange = (changedValues) => {
    //     if(changedValues.searchBy){
    //         form.setFieldsValue({ query: '' })
    //     }
    //     setFormValuesChanged(true);
    // }

    const showAllColumns = (value) => {
        if (value){
            setDisplayColumns(columnsList.map((column) => column.value));
        } else {
            setDisplayColumns('');
        } 
    }

    const filterData = (data, searchText, searchColumn) => {
        if(!searchText) return data;
        if(!searchColumn){
            setSearchColumn('name')
        }
        return data.filter(row => 
            String(row[searchColumn] ?? "")
                .toLowerCase()
                .includes(searchText.toLowerCase())
        );
    };

    return (
        <>
            <Modal
                justifyTitle="left"
                visible={props.visible}
                setVisible={props.setVisible}
                actionGroup={false}
                width={"min(75vw, 1600px)"}
                >
                <div style={{
                    display: 'grid', 
                    gridTemplateColumns: 'minmax(230px, 10vw) 1fr',
                    gap: 24,
                }}>
                    <Card type='secondary' style={{width: '100%', height: '100%'}}>
                        <Space direction='vertical' size='large'>
                            <span>
                                <Space direction='vertical' size='small'>
                                    <Text strong>Table Density</Text>
                                    <Radio.Group defaultValue={tableSize} options={tableSizeOptions} className='layout__vertical' onChange={(e) => setTableSize(e.target.value)}/>
                                </Space>
                            </span>
                            <span>
                                <Space direction='vertical' size='small'>
                                    <Text strong>Columns</Text>
                                    <Space size='small' direction='vertical'>
                                        <Radio.Group value={displayColumns?.length === columnsList.length ? true : displayColumns?.length === 0 ? false : undefined} style={{all: 'none'}} className='layout__vertical' onChange={(e) => showAllColumns(e.target.value)}>
                                            <Radio value={true}>Show All</Radio>
                                            <Radio value={false}>Hide All</Radio>
                                        </Radio.Group>
                                        <Checkbox.Group defaultValue={displayColumns} value={displayColumns} className='layout__vertical' onChange={(e) => filterColumns(e)}>
                                            {columnsList.map((column) => {
                                                return <Checkbox key={column.value} value={column.value}>{column.label}</Checkbox>
                                            })}
                                        </Checkbox.Group>
                                    </Space>
                                </Space>
                            </span>
                            <span>
                                <Space direction='vertical' size='small'>
                                    <Text strong>Device Type</Text>
                                    <Radio.Group value={(!advancedFilters || advancedFilters.searchBy !== 'devices') ? 'all' : advancedFilters.query} options={deviceTypeOptions} className='layout__vertical' onChange={(e) => getFilteredResults({searchBy: 'devices', query: e.target.value})}/>
                                </Space>
                            </span>
                        </Space>
                    </Card>
                    <Flex vertical gap='middle' wrap style={{overflow: 'hidden'}}>
                        <div>
                            <Title level={4} style={{margin: "12px 0"}}>Advanced Search</Title>
                            <Descriptions 
                                colon={false} 
                                size='small'
                                column={{
                                    xxl: 4, 
                                    md: 1,
                                }}  
                            >
                                <Descriptions.Item label='Customer'>{currentNocItem.companyName}</Descriptions.Item>
                                <Descriptions.Item label='Status'><Badge status={customerStatus ? 'success' : 'error'} text={customerStatus ? 'Active' : 'Offline'}/></Descriptions.Item>
                                <Descriptions.Item label='Total Stations'>{dataSource?.length}</Descriptions.Item>
                                <Descriptions.Item label='Total Devices'>{getCustomerStats('devices')}</Descriptions.Item>
                            </Descriptions>
                        </div>
                        <Flex vertical gap='small' wrap>
                            <Text strong>Search</Text>
                            <Flex gap='small'>
                                <Select placeholder='Column' style={{minWidth: 200}} value={searchColumn} onChange={setSearchColumn}>
                                    <Option value='name'>Station Name</Option>
                                    <Option value='address'>Address</Option>
                                    <Option value='comment'>Comment</Option>
                                    <Option value='contractNumber'>Contract Number</Option>
                                    <Option value='oracleID'>Oracle ID</Option>
                                    <Option value='phone'>Phone Number</Option>
                                </Select>
                                <Input.Search
                                    placeholder='Search'
                                    value={searchText}
                                    onChange={e => setSearchText(e.target.value)}
                                />
                                
                                {(searchText || searchColumn) &&
                                    <Button 
                                        type='primary'
                                        onClick={() => {
                                            setSearchText("");
                                            setSearchColumn(undefined)
                                        }}>
                                        Clear
                                    </Button>
                                }
                            </Flex>
                        </Flex>
                        
                        <Table 
                            locale={{
                                emptyText: <Empty description='No data'/>
                            }}
                            size={tableSize}
                            expandable={{
                                expandedRowRender: (record) => (
                                    <>
                                        <Table 
                                            bordered={false}
                                            dataSource={record.Devices}
                                            rowKey='id'
                                            columns={deviceTableColumns}
                                            pagination={{
                                                showTotal: (total, range) => `Total ${total} devices`,
                                                defaultPageSize: 5,
                                                showSizeChanger: true,
                                            }}
                                            style={{marginTop: 20, }}
                                            size='small'
                                            className='nested-table'
                                        />
                                    </>
                                ),
                                rowExpandable: (record) => (displayColumns.includes('devices') && record.Devices?.length > 0),
                            }}
                            columns={columns}
                            dataSource={filterData((advancedFilters ? filteredDataSource : dataSource), searchText, searchColumn)}
                            scroll={{
                                x: (dataSource?.length > 0 && displayColumns.length > 6 ) ? true : false,
                            }}
                            rowKey='id'
                            pagination={
                                {
                                    total: filterData((advancedFilters ? filteredDataSource : dataSource), searchText, searchColumn)?.length,
                                    // total: advancedFilters ? filteredDataSource?.length : dataSource?.length,
                                    defaultCurrent: 1, 
                                    showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} ${advancedFilters ? ` containing "${advancedFilters.query}". Results filtered from ${dataSource?.length} stations.` : ''}`,
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                }
                            }
                        />
                    </Flex>
                </div>
            </Modal>
        </>
    );
}

StationAdvancedFilterModal.defaultProps = {
    visible: false, 
    setVisible: false,
}